import { render } from '.'

render({ root: document.body })
